const STATUS_KEYS = ["status", "publishStatus", "pageStatus", "publishingStatus"] as const;

const isObjectLike = (value: any): value is Record<string, any> =>
  value !== null && typeof value === "object";

const hasStatusKey = (value: any) =>
  isObjectLike(value) && STATUS_KEYS.some((key) => value[key] !== undefined && value[key] !== null);

export const extractPublishStatusPayload = (response: any) => {
  const queue = [response];
  const seen = new Set<any>();

  while (queue.length > 0) {
    const current = queue.shift();

    if (!isObjectLike(current) || seen.has(current)) continue;
    seen.add(current);

    if (hasStatusKey(current)) {
      return current;
    }

    if (current.data !== undefined) queue.push(current.data);
    if (current.result !== undefined) queue.push(current.result);
    if (current.payload !== undefined) queue.push(current.payload);
  }

  return {};
};

export const normalizePublishStatus = (value: any) =>
  String(value || "")
    .trim()
    .toLowerCase();
